import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sn-usc-store-scheduling',
  templateUrl: './usc-store-scheduling.component.html',
  styleUrls: ['./usc-store-scheduling.component.css']
})
export class UscStoreSchedulingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-scheduling/usc-store-scheduling.component.ts